import { ROUTING } from '@/orange/const/routing.const'

export default {
  data () {
    return {
      autoTopupSidebarVisible: false
    }
  },
  methods: {
    goToStep1 () {
      this.$router.push(ROUTING.topup.auto.step1)
    },
    goToStep2 () {
      this.$router.push(ROUTING.topup.auto.step2)
    },
    goToStep3 () {
      this.$router.push(ROUTING.topup.auto.step3)
    },
    toggleAutoTopupSidebar () {
      this.autoTopupSidebarVisible = !this.autoTopupSidebarVisible
    }
  }
}
